import React from 'react'
import AITestContext from '../../../contexts/AITestContext'
import MenuBookIcon from '@mui/icons-material/MenuBook';
import './aitest.css'


export const TestSchoolYear = () => {

  const {
    schoolyear,
    setShowTestSchoolYear,
  } = React.useContext(AITestContext);

const onShowSchoolYear = () => {
  console.log("TestSchoolYear")
  setShowTestSchoolYear(true)
}

  return (
      <div>
          <div style = {{marginBottom:'10px', marginTop:'15px'}}>
            <MenuBookIcon className="languageIcon" style={{paddingLeft: '5px'}} onClick={onShowSchoolYear}/>
            <label className='navbarFonts' style={{paddingLeft: '5px', fontWeight:'700'}}> <span style = {{fontSize:'20px'}}>{schoolyear}</span></label>
        </div>
      </div>
    )
  }
